var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25495 1.86696C6.31962 1.63415 6.18332 1.393 5.95051 1.32833C5.7177 1.26366 5.47655 1.39996 5.41188 1.63277L4.52865 4.81237H2.33341C2.09179 4.81237 1.89591 5.00824 1.89591 5.24987C1.89591 5.49149 2.09179 5.68737 2.33341 5.68737H4.2856L3.3944 8.8957H1.16675C0.925123 8.8957 0.729248 9.09158 0.729248 9.3332C0.729248 9.57483 0.925123 9.7707 1.16675 9.7707H3.15134L2.49521 12.1328C2.43054 12.3656 2.56684 12.6067 2.79965 12.6714C3.03246 12.7361 3.27362 12.5998 3.33829 12.367L4.05947 9.7707H8.40134L7.74521 12.1328C7.68054 12.3656 7.81684 12.6067 8.04965 12.6714C8.28246 12.7361 8.52362 12.5998 8.58829 12.367L9.30947 9.7707H11.6667C11.9084 9.7707 12.1042 9.57483 12.1042 9.3332C12.1042 9.09158 11.9084 8.8957 11.6667 8.8957H9.55253L10.4437 5.68737H12.8334C13.075 5.68737 13.2709 5.49149 13.2709 5.24987C13.2709 5.00824 13.075 4.81237 12.8334 4.81237H10.6868L11.505 1.86696C11.5696 1.63415 11.4333 1.393 11.2005 1.32833C10.9677 1.26366 10.7265 1.39996 10.6619 1.63277L9.77866 4.81237H5.43679L6.25495 1.86696ZM8.6444 8.8957L9.5356 5.68737H5.19373L4.30253 8.8957H8.6444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashIcon);
export default __webpack_public_path__ + "static/media/hashIcon.d09dba377c4730008694e2f6672da776.svg";
export { ForwardRef as ReactComponent };